const config = {
  // Changes see https://dev.azure.com/appsolut365/web%20portals/_wiki/wikis/web-portals.wiki/923/Config-Starter
  siteMetadata: {
    title: 'Post.Sozial',
    description:
      'Der Verein postsozial bietet allen Postmitarbeiter*innen des Aktiv- und Ruhestandes und Mitarbeiter*innen aus bestimmten Tochtergesellschaften der Post AG vergünstigte Urlaubsreisen, finanzielle Unterstützungen und Kulturangebote an.',
    ogImage: '/img/default-og-image.jpg',
    favicon:
      'https://res.cloudinary.com/appsolut365/image/upload/v1641492307/appsolut365/favicons/favicon3_pnwiwl.png',
    docsLocation: '',
    twitter: '@appsolut365',
  },
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://postsozial.at',
    gaTrackingId: null,
    trailingSlash: true,
    hrefLang: 'en',
  },
  modules: {
    multiModuleMode: false,
    catalog: { enabled: true, slug: 'catalog' },
    docs: { enabled: false, slug: 'docs' },
    blog: { enabled: false, slug: 'blog' },
    plan: { enabled: false, slug: 'plan' },
    guideline: { enabled: false, slug: 'guideline' },
    forum: { enabled: false, slug: 'forum' },
  },
  segments: {
    newsletter: { enabled: true },
  },
  pages: {
    slug: 'pg',
    login: { path: '/login/' },
    booking: { path: '/pg/booking/' },
    thankyou: {
      booking: '/pg/form_booking_ok',
      contact: '/pg/form_contact_ok',
      newsletter: '/pg/form_newsletter_ok',
      newsletterConfirm: '/pg/newsletter_confirm_ok',
    },
  },
  catalog: {
    currency: { symbol: '€', code: 'EUR', name: 'Euro' },
    home: { code: 'home' },
    about: { code: 'about' },
    info: { code: 'info' },
    infos: { code: 'infos' },
    privacy: { code: 'privacy' },
    imprint: { code: 'imprint' },
    booking: { code: 'booking', template: 'booking' },
    bookingOk: { code: 'form_booking_ok', template: 'bookingOk' },
    contact: { code: 'form_contact', template: 'contact' },
    contactOk: { code: 'form_contact_ok', template: 'contactOk' },
    newsletter: { code: 'form_newsletter', template: 'newsletter' },
    newsletterOk: { code: 'form_newsletter_ok', template: 'newsletterOk' },
    newsletterConfirm: { code: 'newsletter_confirm', template: 'newsletterConfirm' },
    newsletterConfirmOk: { code: 'newsletter_confirm_ok', template: 'newsletterConfirmOk' },
    sort: { label: 'Sortierung', default: 'title_ASC' },
    search: {
      label: 'Suche',
      code: 'search',
      slug: 'search',
      template: 'search',
      resultPerPage: 24,
    },
    catalog: {
      label: 'Katalog',
      code: 'catalog',
      slug: 'catalog',
      querykey: 'c',
      template: 'catalog',
      primary: 'primary',
      secondary: 'secondary',
      hasSearch: true,
    },
    assortment: { label: 'Sortiment', code: 'assortment', slug: 'as', template: 'assortment' },
    topic: {
      label: 'Themen',
      code: 'topic',
      multi: 'topics',
      slug: 'topic',
      querykey: 't',
      template: 'topic',
    },
    destination: {
      label: 'Reiseziele',
      code: 'destination',
      multi: 'destinations',
      slug: 'destination',
      querykey: 'd',
      template: 'destination',
    },
    triptype: {
      label: 'Unterkunftsarten',
      code: 'triptype',
      multi: 'triptypes',
      slug: 'triptype',
      querykey: 'u',
      template: 'triptype',
    },
    venue: {
      label: 'Häuser',
      code: 'venue',
      multi: 'venues',
      slug: 'venue',
      querykey: 'v',
      template: 'venue',
    },
    patch: {
      label: 'Kennzeichen',
      code: 'patch',
      multi: 'patches',
      querykey: 'p',
    },
    quality: {
      label: 'Klassifizierungen',
      code: 'quality',
      multi: 'qualities',
      querykey: 'k',
    },
    service: {
      label: 'Ausstattung',
      code: 'service',
      multi: 'services',
      querykey: 'g',
    },
    property: {
      label: 'Merkmale',
      code: 'property',
      multi: 'properties',
      querykey: 'm',
    },
    item: { label: 'Leistung', code: 'item', slug: 'item', template: 'product' },
  },
  header: {
    logo: 'https://res.cloudinary.com/appsolut365/image/upload/v1641428921/appsolut365/logo/appsolut/logo_appsolut_base_hell_150_tmtjei.png',
    logoLink: '/',
    title: 'Docs',
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: '',
    links: [
      { text: 'home', link: '/' },
      { text: 'business central', link: '/de-AT/ext-bc/' },
    ],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    title:
      "<span>Post.Sozial </span><div class='greenCircle'></div><a href='/docs'>Dokumentation</a>",
    forcedNavOrder: [], // NOT USED | DEPRECATED
    collapsedNav: [], // NOT USED | DEPRECATED
    links: [
      { text: 'Support', link: 'https://support.appsolut.cloud/hc/de' },
      { text: 'Datenschutz', link: 'https://appsolut.at/privacy/' },
      { text: 'Impressum', link: 'https://appsolut.at/imprint/' },
    ],
    frontline: false,
    ignoreIndex: false,
  },
  forms: {
    field: {
      product: 'Reise',
      user: 'Mitarbeiter*in',
      department: 'Bereich',
      code: 'Personalnummer',
    },
    button: {
      size: 'medium',
      main: {
        variant: 'gradient',
        color: 'info',
      },
      sub: {
        variant: 'text',
        color: 'info',
      },
      label: {
        ok: 'Reservierung Senden',
        back: 'Zurück zum Katalog',
        next: 'Weiter',
        previous: 'Zurück',
        reset: 'Neu Starten',
      },
    },
  },
  api: {
    cmsAccessToken: '2324298a9564d67e808098d29e6ab9', // read-only
    authServerTest: {
      basePath: 'https://api-dev.post.at/postsozial/test/mitarbeiter/api/external',
      key: 'd470d2c5-bc0d-4f54-802f-96f9e9d5b25f',
      subscription: '979e7d061e5b4105aff8283e67729b2d',
    },
    authServer: {
      basePath: 'https://api.post.at/postsozial/mitarbeiter/api/external',
      key: '3009f0b1-f90c-43b5-baa4-4a4f76cd2b3c',
      subscription: 'c4a78b7a4e2b43d9855887b80f4b0b9e',
    },
    flowServer: {
      basePath: 'https://hook.eu1.make.com',
      key: '',
      subscription: '',
    },
    apiServer: {
      basePath: 'https://appsolut-bizconnect.azurewebsites.net/api',
      key: '',
      subscription: '',
    },
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'appsolut Documentation',
      short_name: 'appsolut Docs',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
